module.exports = __webpack_public_path__ + "img/logo-horiz.c1d65f3c.png";